angular.module('rjmNg.directives').directive 'renderHighchartPreview', [
  "colorThemeService"
  (
    colorThemeService
  ) ->
    restrict: "E"
    template: "<div></div>"
    replace: true
    controllerAs: "view"
    bindToController: true
    scope:
      colorThemeId: "="
      type: "@"
    controller: [
      "$scope"
      "$element"
      "$attrs"
      ($scope, $element, $attrs) ->

        view = @

        view.NUMBER_OF_ELEMENTS = 19

        NAMES =
          "column":
            0: "Q1 2017"
            1: "Q2 2017"
            2: "Q3 2017"
            3: "Q4 2017"
            4: "Q1 2018"
            5: "Q2 2018"
            6: "Q3 2018"
            7: "Q4 2018"
            8: "Q1 2019"
            9: "Q2 2019"
            10: "Q3 2019"
            11: "Q4 2019"
            12: "Q1 2020"
            13: "Q2 2020"
            14: "Q3 2020"
            15: "Q4 2020"
            16: "Q1 2021"
            17: "Q2 2021"
            18: "Q3 2021"
            19: "Q4 2021"
          "line":
            0: "Store  1"
            1: "Store  2"
            2: "Store  3"
            3: "Store  4"
            4: "Store  5"
            5: "Store  6"
            6: "Store  7"
            7: "Store  8"
            8: "Store  9"
            9: "Store 10"
            10: "Store 11"
            11: "Store 12"
            12: "Store 13"
            13: "Store 14"
            14: "Store 15"
            15: "Store 16"
            16: "Store 17"
            17: "Store 18"
            18: "Store 19"
            19: "Store 20"

        DATA =
          "column":
            0: [41]
            1: [62]
            2: [77]
            3: [63]
            4: [48]
            5: [66]
            6: [77]
            7: [70]
            8: [57]
            9: [75]
            10: [80]
            11: [68]
            12: [63]
            13: [78]
            14: [91]
            15: [79]
            16: [60]
            17: [86]
            18: [93]
            19: [85]
          "line":
            0: [93, 91, 90, 91, 90, 86, 83, 84, 88, 92, 94, 95, 95, 94, 90, 89, 91, 95, 97, 98, 99, 98, 97, 99]
            1: [88, 85, 84, 85, 85, 83, 80, 80, 84, 88, 89, 91, 92, 90, 85, 83, 85, 90, 92, 95, 95, 95, 93, 94]
            2: [82, 81, 80, 82, 82, 79, 76, 75, 80, 84, 86, 87, 88, 86, 81, 80, 82, 86, 87, 90, 90, 90, 89, 88]
            3: [76, 77, 77, 79, 79, 75, 72, 71, 75, 81, 84, 85, 86, 84, 79, 78, 81, 83, 83, 86, 86, 87, 85, 86]
            4: [70, 71, 73, 74, 73, 70, 66, 68, 73, 76, 77, 79, 80, 78, 73, 72, 75, 77, 77, 81, 82, 83, 81, 82]
            5: [64, 67, 68, 71, 70, 67, 62, 64, 69, 73, 74, 75, 75, 74, 70, 70, 73, 75, 75, 78, 79, 79, 76, 77]
            6: [60, 63, 63, 66, 66, 62, 57, 58, 63, 69, 72, 71, 70, 70, 67, 66, 68, 69, 68, 72, 74, 74, 72, 72]
            7: [54, 57, 58, 62, 63, 59, 53, 55, 60, 65, 67, 67, 66, 66, 64, 63, 65, 66, 65, 69, 70, 69, 67, 66]
            8: [50, 54, 55, 57, 57, 54, 49, 51, 56, 61, 63, 63, 62, 61, 57, 59, 63, 64, 62, 66, 67, 65, 63, 61]
            9: [46, 50, 52, 55, 55, 51, 45, 47, 52, 57, 60, 58, 57, 55, 52, 53, 57, 58, 57, 61, 62, 60, 56, 57]
            10: [42, 46, 48, 51, 51, 47, 41, 43, 48, 53, 56, 54, 52, 52, 49, 49, 53, 55, 55, 58, 59, 56, 51, 52]
            11: [38, 42, 44, 46, 45, 43, 39, 40, 44, 49, 51, 51, 50, 50, 47, 45, 47, 50, 50, 53, 54, 52, 47, 48]
            12: [35, 38, 38, 41, 41, 38, 33, 34, 38, 44, 47, 46, 45, 45, 42, 41, 44, 46, 45, 49, 51, 48, 44, 43]
            13: [32, 35, 35, 38, 38, 34, 29, 30, 34, 39, 41, 42, 42, 42, 39, 38, 40, 42, 42, 44, 46, 43, 40, 39]
            14: [29, 32, 32, 34, 33, 31, 28, 27, 29, 34, 36, 38, 39, 38, 34, 34, 37, 38, 36, 40, 42, 40, 35, 36]
            15: [25, 28, 28, 31, 31, 27, 22, 22, 25, 31, 33, 34, 33, 32, 29, 29, 33, 34, 32, 37, 40, 38, 33, 34]
            16: [18, 22, 24, 26, 26, 23, 19, 18, 20, 25, 27, 28, 28, 28, 26, 25, 28, 29, 27, 31, 33, 32, 28, 29]
            17: [15, 19, 20, 22, 21, 18, 14, 12, 13, 19, 22, 22, 22, 21, 18, 19, 23, 24, 22, 27, 29, 27, 23, 24]
            18: [7, 13, 16, 17, 16, 13, 9, 8, 10, 15, 17, 17, 17, 17, 14, 15, 20, 20, 17, 21, 22, 21, 18, 19]
            19: [3, 8, 10, 11, 9, 7, 3, 2, 3, 8, 11, 12, 13, 12, 8, 9, 13, 14, 12, 17, 18, 16, 12, 14]

        CATEGORIES =
          "column":
            ["Total Revenue"]
          "line": [
            "Jan 2018"
            "Feb 2018"
            "Mar 2018"
            "Apr 2018"
            "May 2018"
            "Jun 2018"
            "Jul 2018"
            "Aug 2018"
            "Sep 2018"
            "Oct 2018"
            "Nov 2018"
            "Dec 2018"
            "Jan 2019"
            "Feb 2019"
            "Mar 2019"
            "Apr 2019"
            "May 2019"
            "Jun 2019"
            "Jul 2019"
            "Aug 2019"
            "Sep 2019"
            "Oct 2019"
            "Nov 2019"
            "Dec 2019"
          ]

        _updateColors = () ->
          for id, series of view.exampleHighchart.series
            series.color = colorThemeService.pickColor(id, view.colorThemeId)

        view.render = () ->
          $element.highcharts()?.destroy()
          _updateColors()
          $element.highcharts(view.exampleHighchart)

        view.$onInit = () ->
          view.exampleHighchart =
            chart:
              backgroundColor: "transparent"
              type: view.type
              zoomType: "xy"
            legend:
              align: "center"
              floating: false
              verticalAlign: "bottom"
            tooltip:
              shared: false
              followPointer: true
              formatter: () ->
                "<div class='chartTooltip'><h4>#{this.x}</h4><span style=\"color:#{this.series.color}\">#{this.series.name}</span> <strong>$ #{this.y}M</strong></div>"
            plotOptions:
              column:
                groupPadding: 0
                pointPadding: 0.05
              line:
                marker:
                  enabled: false
            xAxis:
              categories: CATEGORIES[view.type]
              labels:
                align: "center"
                overflow: "justify"
                rotation: 0
                step: 5
                y: 20
            yAxis:
              labels:
                useHTML: true
                formatter: () -> "$ #{this.value}M"
              min: 0
              max: 100
              plotLines: [
                color: "#aaaaaa"
                value: 0
                width: 1
              ]
            series: []

          for i in [0..view.NUMBER_OF_ELEMENTS]
            view.exampleHighchart.series.push(
              color: "#000000"
              data: DATA[view.type][i]
              marker:
                enabled: false
              name: NAMES[view.type][i]
              yAxis: 0
            )

          if view.colorThemeId?
            view.render()

        view
    ]
    link: (scope, elem, attrs, view) ->

      scope.$watch 'view.colorThemeId', (newId, oldId) ->
        if newId isnt oldId and newId?
          view.render()
  ]
